import { ROOM_CODE_ALPHABET, ROOM_CODE_LENGTH } from './constants';

export function generateRoomCode(length: number = ROOM_CODE_LENGTH): string {
  const alphabet = ROOM_CODE_ALPHABET;
  const limit = Math.floor(256 / alphabet.length) * alphabet.length;
  const out: string[] = [];
  const buf = new Uint8Array(length * 2);
  while (out.length < length) {
    crypto.getRandomValues(buf);
    for (const byte of buf) {
      if (out.length === length) break;
      if (byte >= limit) continue;
      out.push(alphabet[byte % alphabet.length]!);
    }
  }
  return out.join('');
}

export function normalizeRoomCode(raw: string): string | null {
  if (typeof raw !== 'string') return null;
  const code = raw.trim().toUpperCase();
  if (code.length !== ROOM_CODE_LENGTH) return null;
  for (const ch of code) {
    if (!ROOM_CODE_ALPHABET.includes(ch)) return null;
  }
  return code;
}
